import { takeLatest, call, put, select } from "redux-saga/effects";
import {
  GET_AZURE_LOAD_BALANCER,
  GET_AZURE_LOAD_BALANCER_SUCCESS,
  GET_AZURE_LOAD_BALANCER_ERROR,
} from "./constant";

import { getAzureLoadBalancerApi } from "./api";

/**
 * action Type of GET_DASHBOARD_INFO
 * @param {Object} action
 */
function* getAzureLoadBalancerList(params) {
  try {
    const provider = yield select(state => state.CloudProviderStore ? state.CloudProviderStore.selectedProvider : "azure");
    const data = yield call(getAzureLoadBalancerApi, params, provider);
    yield put({ type: GET_AZURE_LOAD_BALANCER_SUCCESS, data });
  } catch (error) {
    yield put({ type: GET_AZURE_LOAD_BALANCER_ERROR, error });
  }
}

/**
 * Get Login Saga
 */
export function* manageAzureLoadBalancerSaga() {
  yield takeLatest(GET_AZURE_LOAD_BALANCER, getAzureLoadBalancerList);
}
